const HomeTooltip = () => {
  return (
    <div className="home-tooltip">
      <br />
      <br />
      <p>GRAĐEVINAR ver 3.1</p>
      <br />
      <p>od</p>
      <p>
        Smart Lab solutions doo, Srbija
        <br /> www.smart-lab-solutions.com
      </p>
      <p>
        Tehnička podrška:
        <br /> support@smart-lab-solutions.com
      </p>
      <p>
        Građevinar je proizvod firme Smart Lab solutions doo
        <br />i kao takav spada pod zaštitu autorskog prava.
      </p>
      <p>© 2025 Smart Lab solutions</p>
    </div>
  );
};

export default HomeTooltip;
